module.exports = __webpack_public_path__ + "img/HSBC.4dd6caec.png";